import styled from "styled-components";

const GroupRow = styled.div<any>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;


export default GroupRow;